// extracted by mini-css-extract-plugin
export default {"LogoDIv":"style_LogoDIv__vxCWi","LogImg":"style_LogImg__jDH7i","mainPriva":"style_mainPriva__j8Glq","paraStart":"style_paraStart__qYu-P"};